<div class="row-centered wrapper">
    <button mat-icon-button (click)="toggleMenu()" fxHide fxShow.lt-sm>
        <mat-icon>menu</mat-icon>
    </button>
    <span *ngIf="title">{{ title }}</span>
</div>
